var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedshift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.1484L21.1266 21.3214V4.22656L12 6.39957V19.1484Z",
    fill: "#205B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1263 4.22656L22.8648 5.09577V20.4522L21.1263 21.3214V4.22656ZM11.9997 19.1484L2.87305 21.3214V4.22656L11.9997 6.39957V19.1484Z",
    fill: "#5193CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87317 4.22656L1.13477 5.09577V20.4522L2.87317 21.3214V4.22656Z",
    fill: "#205B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3188 24.7979L17.7956 23.0594V2.53626L14.3188 0.797852L13.2559 12.1944L14.3188 24.7979Z",
    fill: "#5193CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6819 24.7979L6.20508 23.0594V2.53626L9.6819 0.797852L10.7449 12.1944L9.6819 24.7979Z",
    fill: "#205B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68164 0.797852H14.3654V24.7494H9.68164V0.797852Z",
    fill: "#2E73B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedshift);
export default __webpack_public_path__ + "static/media/Redshift.0f02f4dc1146a886df86fa4fb3c04bcf.svg";
export { ForwardRef as ReactComponent };